var render, staticRenderFns
import script from "./notice-mixin.vue?vue&type=script&lang=js"
export * from "./notice-mixin.vue?vue&type=script&lang=js"
import style0 from "./notice-mixin.vue?vue&type=style&index=0&id=4350a3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350a3ca",
  null
  
)

export default component.exports